import React from "react";
import { useTranslation } from "react-i18next";
import { openAddGoal } from "../../../utils/modal-helpers";
import Modal from "../../modal-new";
import SvgIcon from "../../SvgIcon";

// Steps/sleep/waterIntake are 3 separate goal types on the schema (see
// VALID_GOAL_TYPES, utils/goals-validations.js) - AddGoal.js always needs one
// picked in advance via `modalState`, there is no "daily goals" umbrella
// type there. This picker exists only to feed that choice into AddGoal.js;
// it has no state of its own, so it never needs `toClear` on its own Modal.
const DAILY_GOAL_OPTIONS = [
  {
    modalState: "steps",
    icon: "/img/new-icons/steps.svg",
    labelKey: "annualPlanner.dailyGoalTypeSteps",
  },
  {
    modalState: "sleep",
    icon: "/img/new-icons/sleep.svg",
    labelKey: "annualPlanner.dailyGoalTypeSleep",
  },
  {
    modalState: "waterIntake",
    icon: "/img/new-icons/drop-icon.svg",
    labelKey: "annualPlanner.dailyGoalTypeWater",
  },
];

const SelectDailyGoalTypeModal = () => {
  const { t } = useTranslation("athlete-portal");

  return (
    <Modal
      className="select-daily-goal-type-modal"
      title={t("annualPlanner.selectDailyGoalTypeTitle")}
    >
      <div className="daily-goal-type-options">
        {DAILY_GOAL_OPTIONS.map((option) => (
          <button
            key={option.modalState}
            type="button"
            data-button-type="secondary"
            onClick={() => openAddGoal(option.modalState)}
          >
            <SvgIcon src={option.icon} useCurrentColor classNames="icon-sm" />
            <span>{t(option.labelKey)}</span>
          </button>
        ))}
      </div>
    </Modal>
  );
};

export default SelectDailyGoalTypeModal;
